import { render, staticRenderFns } from "./FiliationPersonalPage.vue?vue&type=template&id=8cc80c4a"
import script from "./FiliationPersonalPage.vue?vue&type=script&lang=js"
export * from "./FiliationPersonalPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports